import React, { useEffect } from 'react';

const TestPage = () => {
  return <div>sample page</div>;
};

export default TestPage;
